import { defineStore } from 'pinia'
import vuetify from '@/plugins/vuetify'

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        language: localStorage.getItem('language') || 'es',
        theme: localStorage.getItem('theme') || 'light'
    }),
    actions: {
        setLenguage(lang) {
            this.language = lang
            localStorage.setItem('language', lang)
        }
        ,
       applyTheme() {
      vuetify.theme.global.name.value=this.theme
     
    },

    toggleTheme() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark'
      localStorage.setItem('theme', this.theme)
      this.applyTheme()
    },

    initTheme() {
      this.applyTheme()
    }
    }
})

